import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppConstants } from '../shared/AppConstants';
import { LoginComponent } from './components/login/login.component';
import { ACCESSTYPES, LOGOUT_REASON } from './_enums/constant-types.enum';
import { PortalFooterElements, PortalProfiles, SearchComponents } from './_models/portals';
import { AppUserInfo, UserLoginResult, UserProfiles } from './_models/user';
import { AlertifyService } from './_services/alertify.service';
import { AuthenticationService } from './_services/authentication.service';
import { HomeService } from './_services/home.service';
import { UtilityService } from './_services/utility.service';
import packageJson from '../../package.json';
import { RequestService } from './_services/request.service';
const Tags_Data_Key = makeStateKey<any>('tags_data');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  //@BlockUI() blockUI: NgBlockUI | undefined;

  //idle properties
  timed: boolean = false;
  idleState = 'Not started.';
  timedOut = false;
  lastPing: Date | null = null;
  countdown: any;
  displayCountdown: any;

  isIdleTimeout: boolean = false;
  sessionExpired = new Subject();
  IsSessionExpired: boolean = false;
  public version: string = '';
  public onClose: Subject<boolean>;
  isLoggedInUser: boolean = false;
  sessionID: string = '';

  LoginStatus$: Observable<boolean>;

  showHeader: boolean = false;
  showFooter: boolean = false;
  isRegProfile: boolean = false;
  cookieToogle: boolean = true;
  cookieSelectionToogle: boolean = false;
  subscribeGetPortal: Subscription | null = null;
  private subRouteQueryParams: Subscription | null = null;
  userProfilesList: Array<UserProfiles>;
  userAuthenticationType: string | null;
  portalProfiles?: PortalProfiles[];
  selectedList: any;
  selectedFromPopup: boolean = false;
  footerElements?: PortalFooterElements;
  platformId: any;
  url?: string;
  CurrentTags: any;
  userDetailsJson: any;
  
  TagsData$: any;

  CurrentTags$: any;
  allTags$: any;
  _page: any;
  actionPerformed: boolean = false;
  constructor(public utilityService: UtilityService,
    public authService: AuthenticationService,
    private homeService: HomeService,
    public modalRef: BsModalRef,
    private modalService: BsModalService,
    public router: Router,
    private activateRoute: ActivatedRoute,
    private alertify: AlertifyService,
    private idle: Idle, private metaTagService: Meta,
    private reqservice: RequestService,
    @Inject(PLATFORM_ID) platformId: any,) {
    this.platformId = platformId;
    this.onClose = new Subject();
    this.version = packageJson.version;

    this.setSEOTags();

    this.portalProfiles = AppConstants.PortalProfiles;
    /**
     * on route change to '/account-verify' and /account-resetpassword, set the variable showHeader, showFooter to false
     */

    if (isPlatformBrowser(this.platformId)) {
      this.isLoginProfile();
    }
    
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'].indexOf('/account-verify') <= -1
          && event['url'].indexOf('/account-resetpassword') <= -1
          && event['url'].indexOf('/event-unsubscribe') <= -1
          && event['url'].indexOf('/news-unsubscribe') <= -1) {
          this.showHeader = true;
          this.showFooter = true;
        } else {
          this.showHeader = false;
          this.showFooter = false;
        }
      }
    });

    //idle.setIdle(10);// sets an idle timeout of x time
    //idle.setTimeout(AppConstants.SessionInactiveTime); // sets a timeout period of x time. after 10 seconds of inactivity, the user will be considered timed out.
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document

    idle.setIdle(AppConstants.SessionIdleTimeout * 60);
    idle.setTimeout(1);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
    });

    idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.displayCountdown = this.secondsToTime(countdown);
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
      this.isIdleTimeout = true;
      //console.log(countdown)
      if (countdown == 1) {
        this.timed = true;
        //console.log("I am happy");
        if (authService.isUserLoggedIn()) {
          authService.logout();
          authService.sessionExpired();
          this.router.navigate(['/'], { queryParams: { referrer: 'SESSION_EXPIRED' } })
            .then(() => {
              this.utilityService.setSessionExpired();
              if (isPlatformBrowser(this.platformId)) {
                window.location.reload();
              }
            });
        }
      }
    });

    this.resetTimeout();
  }

  isLoginProfile() {
    if (this.portalProfiles && this.portalProfiles.length == 1 && this.portalProfiles[0].ACCESS_TYPE_CODE == ACCESSTYPES.AUTHENTICATED
      && !this.portalProfiles[0].IS_LOGIN_OPTIONAL) {
        this.isRegProfile = false;
    }
    else {
      this.isRegProfile = true;
    }
  }

  closeTimeoutPopup() {
    this.IsSessionExpired = false;
    this.resetTimeout();
    this.router.navigate(['/']);
  }

  resetTimeout() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.sessionID = '';
    this.timedOut = false;
    this.isIdleTimeout = false;
    this.IsSessionExpired = false;
  }

  ngOnInit() {
    this.getFooterData();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map((e: NavigationEnd) =>
        // isPlatformBrowser(this.platformId) ? window.location.href = this.url = e.urlAfterRedirects : this.url = e.urlAfterRedirects
        this.url = e.urlAfterRedirects
      )
    ).subscribe(pageurl => {
    });

    this.refreshOnBackButtonClick();
    //#region CHECK FOR MULTI SESSION LOGGIN
    if (isPlatformBrowser(this.platformId)) {
      const connection = this.authService.getSignalRconnection();
      connection.start().then(function () {
        console.trace('CP Hub Connected!');
      }).catch(function (err) {
        console.log(err.toString());
        return console.error(err.toString());
      });
      if (connection) {
        connection.on("MultiBrowserLogInMessage", (resp) => {
          let loggedIntest = this.authService.isUserLoggedIn();//checking is user logged in
          if (loggedIntest) {
            this.userDetailsJson = localStorage.getItem('cpappuserinfo');
            if (this.userDetailsJson) {
              let userId = JSON.parse(this.userDetailsJson).PK_UserId;
              if (resp.data.userId == userId) {
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.setItem('lr', 'Session Override');
                this.authService.multiLogout(LOGOUT_REASON.SESSION_OVERRIDE);
                this.alertify.ConfirmationBanner(resp.data.name, this.navigateToHome(), "Ok", "", false);
              }
            }
          }
        });

        connection.on("GetUserCountService", (resp: { data: any }) => {
          let userInfo = localStorage.getItem('cpappuserinfo');
          if (userInfo) {
            const userId = JSON.parse(userInfo).PK_UserId;
            if (resp.data.userId == userId) {
              this.reqservice.userNotifCountSubject$.next(undefined);
            }
          }

        });
      }

    }
    //#endregion CHECK FOR MULTI SESSION LOGGIN
    
    if (this.portalProfiles && this.portalProfiles.length == 1 && this.portalProfiles[0].ACCESS_TYPE_CODE == ACCESSTYPES.AUTHENTICATED
      && !this.portalProfiles[0].IS_LOGIN_OPTIONAL) {
      this.showHeader = false;
      this.utilityService.isProfileSelection = false;
      this.utilityService.actionOnSelfQualification(true);
      this.homeService.setselectedProfile(this.portalProfiles[0]);
      if (isPlatformBrowser(this.platformId)) {
        localStorage.removeItem('profInfo');
        localStorage.setItem('profInfo', JSON.stringify(this.portalProfiles[0]));
      }
      let loggedIn = this.authService.isUserLoggedIn();//checking is user logged in
      if (!loggedIn) {
        this.authService.sessionIdleTimeout();
        this.GenerateGuestToken(this.portalProfiles[0].PK_ENV_PROFILE_ID ?? '');
        this.loginPopup();
        return;
      }
    }
    let loggedIn = this.authService.isUserLoggedIn();//checking is user logged in
    if (loggedIn) {
      this.authService.check();//checking session timeout
      this.authService.setEnv();//adding portal data to portal variable in utility service
      this.utilityService.setEnv();// setting appconstants reportertype id ,hcp,non hcp rt names
      let userdata: AppUserInfo = this.utilityService.getAppUserInfo();
      if (userdata && userdata.ACCESS_TYPE_CODE && userdata.FK_ENV_PROF_ID) {
        let profiledata: PortalProfiles = {
          ACCESS_TYPE_CODE: userdata.ACCESS_TYPE_CODE,
          PK_ENV_PROFILE_ID: userdata.FK_ENV_PROF_ID,
          NAME: userdata.ENV_PROFILE,
          PROF_TYPE_CODE: userdata.PROF_TYPE_CODE,
          IS_LOGIN_OPTIONAL: userdata.IS_LOGIN_OPTIONAL,
        }
        this.NavigatePortalUser(profiledata);
      }
      else {
        localStorage.setItem('isLoggedIn', 'false');
        let profileinfo: PortalProfiles = {};
        profileinfo = this.utilityService.getSelectedProfile();
        if (profileinfo.ACCESS_TYPE_CODE == ACCESSTYPES.AUTHENTICATED) {
          this.showHeader = false;
          this.utilityService.isProfileSelection = false;
          this.utilityService.actionOnSelfQualification(true);
          this.homeService.setselectedProfile(profileinfo);
          //this.setFeaturesList(profileinfo);
          if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('profInfo');
            localStorage.setItem('profInfo', JSON.stringify(profileinfo));
          }
          this.loginPopup();
        }
        else if (profileinfo.ACCESS_TYPE_CODE == ACCESSTYPES.NO_ACCESS) {
          this.actionOnIamNonHCP();
        }
      }
    }
    if (!loggedIn) {
      let profileinfo: PortalProfiles = {};
      profileinfo = this.utilityService.getSelectedProfile();
      if (profileinfo.ACCESS_TYPE_CODE == ACCESSTYPES.AUTHENTICATED) {
        this.showHeader = false;
        this.utilityService.isProfileSelection = false;
        this.utilityService.actionOnSelfQualification(true);
        this.homeService.setselectedProfile(profileinfo);
        //this.setFeaturesList(profileinfo);
        if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem('profInfo');
          localStorage.setItem('profInfo', JSON.stringify(profileinfo));
        }
        this.loginPopup();
      }
      else if (profileinfo.ACCESS_TYPE_CODE == ACCESSTYPES.NO_ACCESS) {
        this.actionOnIamNonHCP();
      }
    }
    this.IsSessionExpired = false;
    this.resetTimeout();
    this.cookieToogle = !this.authService.isCookie();
    if (this.utilityService.isProfileSelected() || !this.utilityService.isProfileSelection) {
      this.utilityService.isProfileSelection = false;
      this.utilityService.actionOnSelfQualification(true);
      if (isPlatformBrowser(this.platformId)) {
        let profileinfo: PortalProfiles = {};
        profileinfo = this.utilityService.getSelectedProfile();
        if (profileinfo.PK_ENV_PROFILE_ID) {
          this.homeService.setselectedProfile(profileinfo);
          let tkn = localStorage.getItem('access_token')
          if (tkn) {
            this.getUserProfileFeatures(profileinfo.PK_ENV_PROFILE_ID)
          }
          else {
            //this.NavigatePortalUser(profileinfo);
            let featureList: any;
            this.homeService.featureProfileObserver.subscribe((response) => {
              featureList = response;
              if (featureList && featureList.length > 0) {
                this.setFeaturesList(featureList)
              }
            });
          }
        }
        else {
          this.utilityService.isProfileSelection = true;
          this.utilityService.actionOnSelfQualification(false);
        }
      }
      return;
    }
    this.LoginStatus$ = this.authService.isLoggedIn;
    this.subRouteQueryParams = this.activateRoute.queryParams.subscribe({
      next:
        params => {
          let referrer = params['referrer'];
          this.sessionID = referrer != null && referrer != "" ? referrer : null;
          if (this.sessionID == 'SESSION_EXPIRED') {
            if (!this.authService.isUserLoggedIn()) {
              this.IsSessionExpired = true;
            }
            else {
              this.router.navigate(['/']);
            }
          }
          else {
            this.IsSessionExpired = false;
          }
        }, error: (err) => {

          this.alertify.errorBaner("Error occured while navigating to the requested resource. Please check detailed error:\n\n" + err);
        }
    });
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('storage', (event) => {
        if (event.key == 'logout-event') {
          this.router.navigate(['/'])
            .then(() => {
              window.location.reload();
            });
        }
      }, false);
    }
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('storage', (event) => {
        if (event.key == 'timeout-event') {
          this.utilityService.setSessionExpired();
          this.router.navigate(['/'], { queryParams: { referrer: 'SESSION_EXPIRED' } })
            .then(() => {
              this.utilityService.setSessionExpired();
              window.location.reload();
            });
        }
      }, false);
    }
  }

  refreshOnBackButtonClick(): void {
    this.router.events.subscribe((event: any) => {
      if (event.navigationTrigger === 'popstate') {
        if (isPlatformBrowser(this.platformId)) {
          window.location.reload();
        }

      }
    });
  }

  getFooterData(): void {
    this.homeService.getFooterData().subscribe({
      next: (data: PortalFooterElements) => {
        if (data) {
          this.footerElements = data;
        }
        else {
          this.footerElements = {};
        }
      },
      error: (err) => {
        this.footerElements = {};
        console.log(err);
      }
    })
  }

  secondsToTime(d: any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? (h.toString().length == 1 ? '0' + h : h) : "00";
    var mDisplay = m > 0 ? (m.toString().length == 1 ? '0' + m : m) : "00";
    var sDisplay = s > 0 ? (s.toString().length == 1 ? '0' + s : s) : "00";
    return hDisplay + ":" + mDisplay + ":" + sDisplay;
  }

  close() {
    this.onClose.next(false);
    this.modalRef.hide();
  }

  openLoginForm() {
    this.close();
    this.IsSessionExpired = false;
    this.router.navigate(['/']);
    this.loginPopup();
  }

  loginPopup() {
    const initialState: ModalOptions = {
      backdrop: 'static',
      class: 'modal-dialog-centered',
      keyboard: false
    };
    this.modalRef = this.modalService.show(LoginComponent, initialState);
    this.modalRef.content.closeBtnName = 'Close';
    this.modalRef.content.onLogin.subscribe((result: UserLoginResult) => {
      if (result != null) {
        this.authService.loginStatus.next(true);
        this.authService.UserFullName.next(result.UserFullName ?? "");
        this.authService.hcpDetails.next(this.utilityService.getAppUserInfoObject(result));
        this.isLoggedInUser = this.authService.isUserLoggedIn();
      }
    });
  }

  actionOnIamHCP() {
    this.utilityService.actionOnSelfQualification(true);
  }

  actionOnIamNonHCP() {
    this.utilityService.isProfileSelection = true;
    this.utilityService.isNonHCP = true;
  }

  NavigatePortalUser(userProfile: PortalProfiles, selectedFromPopup: boolean = false) {
    this.selectedFromPopup = selectedFromPopup;
    this.utilityService.actionOnSelfQualification(true);
    AppConstants.ReporterTypeId = userProfile.PK_ENV_PROFILE_ID;
    AppConstants.ReporterTypeName = userProfile.NAME;
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('RT_ID', userProfile.PK_ENV_PROFILE_ID ?? '');
      this.homeService.setselectedProfile(userProfile);
      if (userProfile) {
        localStorage.removeItem('profInfo');
        localStorage.setItem('profInfo', JSON.stringify(userProfile));
      }
    }


    if (userProfile.ACCESS_TYPE_CODE == ACCESSTYPES.NO_ACCESS) {
      this.actionOnIamNonHCP();
    }
    else if (userProfile.ACCESS_TYPE_CODE == ACCESSTYPES.AUTHENTICATED && !this.authService.isUserLoggedIn()) {
      this.close();
      this.GenerateGuestToken(userProfile.PK_ENV_PROFILE_ID ?? '');
      this.loginPopup();
    }
    else if (userProfile.ACCESS_TYPE_CODE == ACCESSTYPES.GUEST) {
      this.GenerateGuestToken(userProfile.PK_ENV_PROFILE_ID ?? '');
    }

    this.authService.sessionIdleTimeout();
  }

  getUserProfileFeatures(userProfileId: string) {
    let data: SearchComponents = {
      ProfileId: userProfileId
    }
    this.homeService.getUserProfileFeatures(data).subscribe({
      next: (data) => {
        if (data) {
          this.setFeaturesList(data)
        } else {
          console.log("No User Profile Data")
        }
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

  setFeaturesList(profileFeature: any): void {
    this.homeService.setUserProfileFeaturesList(profileFeature);
    this.homeService.setFeatures(this.selectedFromPopup);
    this.selectedFromPopup = false;
  }

  onBack() {
    this.utilityService.isNonHCP = false;
    this.utilityService.isProfileSelection = true;
  }

  onNonHCPClose() {
    this.utilityService.IsNotHcpAction = false;
  }


  allowCookies() {
    this.cookieToogle = false;
    this.cookieSelectionToogle = false;

    if (!this.authService.isCookie()) {
      this.authService.storeCookie();
    }
  }

  closeCookies() {
    this.cookieToogle = false;
  }

  cookieSelection() {
    this.cookieSelectionToogle = true;
  }


  @HostListener('window:unload')
  async ngOnDestroy() {
    if (!this.authService.isUserLoggedIn()) {
      if (isPlatformBrowser(this.platformId)) {
        localStorage.removeItem('UserAuthenticationType');
        sessionStorage.removeItem('IS_HCP');
      }

    }
  }

  GenerateGuestToken(profileId: string) {
    this.homeService.generateGuestToken().subscribe({
      next: (data) => {
        if (data) {
          console.log("Guest token generated successfully.")
          this.getUserProfileFeatures(profileId);
        } else {
          console.log("Guest token generation failed.")
        }
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

  getCurrentPageTags(Code: string) {
    let features = this.TagsData$;
    let tagData = features.filter((x: any) => { return x.FeatureCode == Code })[0];
    return tagData;
  }

  navigateToHome() {
    let url = this.homeService._setFeatures();
    this.router.navigate([url]);
  }

  setSEOTags() {
    this.metaTagService.addTags([
      { name: "description", content: "" },
      { name: "title", content: '' },
      { name: 'robots', content: 'index, follow' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ]);
  }

}



